import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Container from 'components/Container';
import Main from 'layouts/Main';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { coworkingViewHelmet } from '../../components/useHelmet';
import {
  Advantages,
  Benefits,
  Contact,
  Description,
  Hero,
  Locations,
  MapHero,
} from './components';

const Coworking = () => {
  const theme = useTheme();
  const [openBottombar, setOpenBottombar] = useState(false);

  const handleBottombarOpen = () => {
    setOpenBottombar(true);
  };

  const handleBottombarClose = () => {
    setOpenBottombar(false);
  };

  return (
    <Main>
      <Helmet>
        <title>{coworkingViewHelmet.title}</title>
        <meta
          name="description"
          content={coworkingViewHelmet.metaDescription1}
        />
        <meta name="keywords" content={coworkingViewHelmet.metaKeyWords} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:site"
          content={coworkingViewHelmet.twitterCards.site}
        />
        <meta
          name="twitter:title"
          content={coworkingViewHelmet.twitterCards.title}
        />
        <meta
          name="twitter:description"
          content={coworkingViewHelmet.twitterCards.description}
        />
        <meta
          name="twitter:image"
          content={coworkingViewHelmet.twitterCards.image}
        />
        <meta
          property="og:site_name"
          content={coworkingViewHelmet.ogp.site_name}
        />
        <meta property="og:type" content={coworkingViewHelmet.ogp.type} />
        <meta property="og:title" content={coworkingViewHelmet.ogp.title} />
        <meta
          property="og:description"
          content={coworkingViewHelmet.ogp.description}
        />
        <meta property="og:url" content={coworkingViewHelmet.ogp.url} />
        <meta property="og:image" content={coworkingViewHelmet.ogp.image} />
        <meta property="og:locale" content={coworkingViewHelmet.ogp.locale} />
      </Helmet>
      <Hero />
      <Container>
        <Description />
      </Container>
      <Box>
        <Benefits />
      </Box>
      <Box bgcolor={theme.palette.alternate.main}>
        <Container zIndex={1}>
          <Advantages />
        </Container>
      </Box>
      <Divider />
      <Container>
        <Locations />
      </Container>
      <Box bgcolor={theme.palette.alternate.main}>
        <MapHero />
      </Box>

      <AppBar
        position="fixed"
        sx={{
          top: 'auto',
          bottom: 0,
          background: 'transparent',
          boxShadow: 'none',
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            width: '100%',
            margin: '0 auto',
            padding: theme.spacing(0, 2),
          }}
        >
          <IconButton
            sx={{
              position: 'absolute',
              right: theme.spacing(3),
              left: 'auto',
              top: theme.spacing(-3),
              background: theme.palette.primary.main,
              width: 55,
              height: 55,
              boxShadow: 4,
              '&:hover': {
                background: theme.palette.primary.dark,
              },
            }}
            onClick={handleBottombarOpen}
          >
            <Box
              component={'svg'}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              width={24}
              height={24}
              color={theme.palette.common.white}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
              />
            </Box>
          </IconButton>
          <Drawer
            anchor="bottom"
            open={openBottombar}
            onClose={handleBottombarClose}
          >
            <Container
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
            >
              <IconButton
                sx={{
                  width: 48,
                  height: 48,
                  boxShadow: 4,
                  marginBottom: theme.spacing(4),
                }}
                onClick={handleBottombarClose}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  width={24}
                  height={24}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </IconButton>
              <Contact />
            </Container>
          </Drawer>
        </Toolbar>
      </AppBar>
    </Main>
  );
};

export default Coworking;
